import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import dayjs from 'dayjs';

import { FileDetail, InfoDetailResType, useGetInfoDetailApi } from '@/api/notice';
import mainBanner from '@/assets/img/banner/info.jpg';
import shareIcon from '@/assets/img/icon/shareIcon.svg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import ModalShare from '@/components/common/Modal/ModalShare/ModalShare';
import DownloadIcon from '@/components/Icon/DownloadIcon';
import LineIcon from '@/components/Icon/lineIcon';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import SingleArrowPrev from '@/components/Icon/SingleArrowPrev';
import { SPONSORSHIP_MENU_ANNUAL_DONATION } from '@/constants/sponsorship';
import { convertInfoValue } from '@/utils/convertValue';
import { downloadFile } from '@/utils/fileUtils';

import * as S from '@/components/Information/InformationNotice/InformationNoticeDetail/style';

const listState = { menu: SPONSORSHIP_MENU_ANNUAL_DONATION };

const SponsorshipDonationDetail = () => {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const { id } = params;
	const paramsMenu = location.state?.menu ?? SPONSORSHIP_MENU_ANNUAL_DONATION;
	const [isOpenShare, setIsOpenShare] = useState(false);

	const { data: infoDetailData } = useGetInfoDetailApi({
		info_pk: id ?? '',
		type: convertInfoValue(paramsMenu),
	});

	const getDynamicField = (g: Record<string, unknown>, field: string) => {
		const type = convertInfoValue(paramsMenu);
		const key = `${type}_${field}`;
		return String(g[key] ?? '');
	};

	const getDynamicFieldFile = (data: InfoDetailResType | undefined, field: string): FileDetail[] | undefined => {
		const type = convertInfoValue(paramsMenu);
		const key = `${type}_${field}` as keyof InfoDetailResType;
		const value = data?.[key];
		return Array.isArray(value) ? value : undefined;
	};

	const formatBytesToKB = (bytes: number) => `${Math.round(bytes / 1024)} KB`;

	const detail = infoDetailData?.donation;
	const detailObj = (detail ?? {}) as Record<string, unknown>;

	return (
		<>
			<main>
				<SubBanner subTitle="Sponsorship" title="후원안내" img={mainBanner} />
				<S.ConferenceContainer>
					<S.ConferenceHeader>
						<S.ConferenceTitleBox>
							<S.ConferenceTitle>{getDynamicField(detailObj, 'title')}</S.ConferenceTitle>
							<S.ConferenceSubTitle>
								{dayjs(getDynamicField(detailObj, 'enrollment_date')).format('YYYY-MM-DD')}
								<LineIcon />
								조회수:
								{getDynamicField(detailObj, 'hit') ? getDynamicField(detailObj, 'hit') : '0'}
								<LineIcon />
								작성자: {detail?.admin_name}
							</S.ConferenceSubTitle>
						</S.ConferenceTitleBox>
						<div className="share_icon">
							<S.ImgBox onClick={() => setIsOpenShare(!isOpenShare)}>
								<img src={shareIcon} alt="share" />
							</S.ImgBox>
						</div>
					</S.ConferenceHeader>
					<S.ContentBox>
						<S.Content dangerouslySetInnerHTML={{ __html: getDynamicField(detailObj, 'content') }} />
						<S.DownLoadBoxList>
							{infoDetailData &&
								getDynamicFieldFile(infoDetailData, 'file')?.map((item, index) => (
									<S.DownLoadBox key={index} onClick={() => downloadFile(item.file_path ?? '', item.file_pk ?? '')}>
										<S.DownLoadContent>
											<div className="title">{item.file_original_name ?? ''}</div>
											<div className="sub_title">{formatBytesToKB(item.file_size ?? 0)}</div>
										</S.DownLoadContent>
										<DownloadIcon iconColor="#ADB5BD" width="20" height="20" />
									</S.DownLoadBox>
								))}
						</S.DownLoadBoxList>
						<S.MenuBox>
							<S.MenuList>
								{!infoDetailData?.prev_pk ? (
									<></>
								) : (
									<S.Menu
										type="button"
										onClick={() => navigate(`/sponsorship/donation/${infoDetailData.prev_pk}`, { state: listState })}
									>
										<SingleArrowPrev iconColor="#212529" width="18" height="18" /> 이전글
									</S.Menu>
								)}
								{!infoDetailData?.next_pk ? (
									<></>
								) : (
									<S.Menu
										type="button"
										onClick={() => navigate(`/sponsorship/donation/${infoDetailData.next_pk}`, { state: listState })}
									>
										다음글
										<SingleArrowNext iconColor="#212529" width="18" height="18" />
									</S.Menu>
								)}
							</S.MenuList>
							<S.MenuList>
								<S.MenuActive type="button" onClick={() => navigate('/sponsorship', { state: listState })}>
									목록
								</S.MenuActive>
							</S.MenuList>
						</S.MenuBox>
					</S.ContentBox>
				</S.ConferenceContainer>
			</main>
			{isOpenShare && (
				<ModalPortal>
					<ModalShare onClick={setIsOpenShare} />
				</ModalPortal>
			)}
		</>
	);
};

export default SponsorshipDonationDetail;
